"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const uuidv1 = require("uuid/v1");
const TypeScriptUtils_1 = require("../../Common/TypeScriptUtils");
var CmdType;
(function (CmdType) {
    CmdType["None"] = "None";
    CmdType["RequestExecute"] = "RequestExecute";
    CmdType["RequestCancel"] = "RequestCancel";
    CmdType["ResponseAccept"] = "ResponseAccept";
    CmdType["ResponseFail"] = "ResponseFail";
    CmdType["ResponseReject"] = "ResponseReject";
})(CmdType = exports.CmdType || (exports.CmdType = {}));
var TransportType;
(function (TransportType) {
    TransportType["WebSync"] = "WebSync";
    TransportType["Http"] = "Http";
})(TransportType = exports.TransportType || (exports.TransportType = {}));
class RtcCommand {
    constructor(cmd) {
        this.id = "";
        this.category = "";
        this.name = "";
        this.type = CmdType.None;
        this.transport = TransportType.WebSync;
        this.content = {};
        this.sender = "";
        this.isToService = false;
        this.receivers = [];
        this.targetId = "";
        this.timestamp = 0;
        this.message = "";
        if (cmd) {
            this.id = cmd.id ? cmd.id : this.id;
            this.category = cmd.category || this.category;
            this.name = cmd.name || this.name;
            this.type = cmd.type || this.type;
            this.transport = cmd.transport || this.transport;
            if (cmd.content !== undefined && cmd.content !== null) {
                this.content = cmd.content;
            }
            this.sender = cmd.sender || this.sender;
            this.isToService = cmd.isToService || this.isToService;
            this.receivers = cmd.receivers ? cmd.receivers.slice() : this.receivers;
            this.targetId = cmd.targetId || this.targetId;
            this.timestamp = cmd.timestamp || Date.now();
            this.message = cmd.message || this.message;
        }
    }
    isValid() {
        return !TypeScriptUtils_1.isNullOrEmpty(this.id) //Id不為空字串
            && !TypeScriptUtils_1.isNullOrEmpty(this.category) //分類不為空字串
            && !TypeScriptUtils_1.isNullOrEmpty(this.name) //名字不為空字串
            && (this.type !== CmdType.None); //Command種類不為None
    }
    toString() { return JSON.stringify(this, null, 4); }
    contentTo() {
        if (typeof this.content === "string") {
            return TypeScriptUtils_1.parseJsonString(this.content);
        }
        else {
            return this.content;
        }
    }
    //public static Builder(): RtcCommandBuilder;
    static Builder(rtcCmd) {
        if (rtcCmd)
            return new RtcCommandBuilder(rtcCmd);
        else
            return new RtcCommandBuilder();
    }
    static deserializeFromJsonString(jsonString) {
        const parsed = JSON.parse(jsonString);
        //const deSerialized = new RtcCommand(<RtcComamndConstructorParameter>parsed);
        const deSerialized = new RtcCommand();
        Object.assign(deSerialized, parsed);
        return deSerialized;
    }
}
RtcCommand.InvalidRtcCommand = new RtcCommand();
exports.RtcCommand = RtcCommand;
class RtcCommandBuilder {
    constructor(cmd) {
        if (cmd) {
            this._cp = {
                id: cmd.id,
                category: cmd.category,
                name: cmd.name,
                type: cmd.type,
                transport: cmd.transport,
                content: cmd.content,
                sender: cmd.sender,
                isToService: cmd.isToService,
                receivers: cmd.receivers.slice(),
                targetId: cmd.targetId,
                timestamp: Date.now(),
                message: cmd.message,
            };
        }
        else {
            this._cp = {
                receivers: []
            };
        }
    }
    Id(id) { this._cp.id = id; return this; }
    AutoId() { this._cp.id = uuidv1(); return this; }
    Category(cat) { this._cp.category = cat; return this; }
    CmdTypeAction(t) { this._cp.type = t; return this; }
    Transport(tt) { this._cp.transport = tt; return this; }
    Name(name) { this._cp.name = name; return this; }
    Sender(sender) { this._cp.sender = sender; return this; }
    IsToService(isToService) { this._cp.isToService = isToService; return this; }
    ClearReceiver() { this._cp.receivers = []; return this; }
    AddReceiver(receiver) { this._cp.receivers.push(receiver); return this; }
    AddReceivers(receivers) { this._cp.receivers = this._cp.receivers.concat(receivers); return this; }
    Receivers(receivers) { this._cp.receivers = receivers.slice(); return this; }
    Receiver(reciver) { this._cp.receivers = []; this._cp.receivers.push(reciver); return this; }
    TargetId(targetId) { this._cp.targetId = targetId; return this; }
    Content(content) { this._cp.content = content; return this; }
    TimeStamp(timestamp) { this._cp.timestamp = timestamp; return this; }
    Message(msg) { this._cp.message = msg; return this; }
    Build() {
        return new RtcCommand(this._cp);
    }
}
exports.RtcCommandBuilder = RtcCommandBuilder;
//# sourceMappingURL=RtcCommand.js.map